export const ApplicationRoles = {
  accounting: 'Accounting',
  activityAssign: 'ActivityAssign',
  crm: 'Crm',
  folio: 'Folio',
  groups: 'Groups',
  inboxCoordinator: 'InboxCoordinator',
  mirAdmin: 'MirAdmin',
  officeAdmin: 'OfficeAdmin',
  obtUser: 'ObtUser',
  reservations: 'Reservations',
  staff: 'Staff',
  systemAdmin: 'SystemAdmin',
  userAdmin: 'UserAdmin',
  developer: 'Developer',
  alwaysJoinWorkflow: 'AlwaysJoinWorkflow',
  activityAdmin: 'ActivityAdmin',
  resManager: 'ResManager',
  accountManager: 'AccountManager',
  businessDevelopmentManager: 'BusinessDevelopmentManager',
  staffBeta: 'StaffBeta',
  supportAdmin: 'SupportAdmin'
};

export const AllAccessRoles = [ApplicationRoles.systemAdmin, ApplicationRoles.developer];
